import styled from 'styled-components';

const LandingModalTitle = styled.h2`
  text-align: center;
  margin-bottom: 20px;
`;

export default LandingModalTitle;
